import React, { useState } from "react";
import classnames from "classnames";
import styles from "./Navbar.module.scss";
import { Col, Row, Button } from "reactstrap";
import logo from "../../assets/logo.svg";

const navbar = window._edo_settings.navbar;
const navbarOptions = window._edo_settings.navbar_options || {}
const navbarDonate = navbarOptions.donate

const search = (<>
  <a href="#" aria-label="Search Icon Link">
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.01233 11.5C3.11805 11.5 0.75 9.1375 0.75 6.25C0.75 3.3625 3.11805 1 6.01233 1C8.90662 1 11.2747 3.3625 11.2747 6.25C11.2747 9.1375 8.90662 11.5 6.01233 11.5ZM6.01233 1.4875C3.41875 1.4875 1.23865 3.6625 1.23865 6.25C1.23865 8.8375 3.41875 11.0125 6.01233 11.0125C8.60591 11.0125 10.786 8.8375 10.786 6.25C10.786 3.6625 8.60591 1.4875 6.01233 1.4875ZM12.5151 13C12.4775 13 12.3647 13 12.3271 12.9625L9.35767 10C9.24491 9.8875 9.24491 9.7375 9.35767 9.6625C9.47044 9.5875 9.62079 9.55 9.69597 9.6625L12.6654 12.625C12.7782 12.7375 12.7782 12.8875 12.6654 12.9625C12.6654 13 12.5902 13 12.5151 13Z"
        fill="#222221"
        stroke="#222221"
      />
    </svg>
  </a>
  <form method="get" id="searchform" action="/" role="search" style={{ display: 'none' }}>
    <label className="sr-only" for="s">Search</label>
    <div className="input-group">
      <input className="field form-control" id="s" name="s" type="text" placeholder="Search …" />
      <span className="input-group-append">
        <input className="submit btn btn-primary" id="searchsubmit" name="submit" type="submit" value="Search" />
      </span>
    </div>
  </form>
</>)

const Navbar = () => {
  return (
    <>
      <Row className={[styles.navHeight, styles.onlyLg]}>
        <Col md={3} className={styles.navContainer}>
          <a href="/">
            <img className={styles.logoLg} src={logo} alt="Environmental Defenders Office Logo" />
            <span class="sr-only">Environmental Defenders Office</span>
          </a>
        </Col>
        <Col md={8} className={styles.navUlContainer}>
          <ul className={styles.navUl}>
            {navbar.map(item =>
              <li key={item.id} className={styles.navList}>
                <a href={item.url} className={styles.navNavitagion}>
                  {item.title}
                </a>
              </li>
            )}
            <li className={classnames("astm-search-menu is-menu is-dropdown menu-item", styles.navListFind)}>
              {search}
            </li>
          </ul>
        </Col>
        {navbarDonate
          ? <Col md={1} className={styles.navContainer}>
            <Button tag="a" href={navbarDonate.url} className={styles.navButton}>
              {navbarDonate.title}
            </Button>
          </Col>
          : null}
      </Row>
      <Row className={[styles.navHeight, styles.onlyXs]}>
        <Col lg={3} xs={12} className={[styles.navContainer, styles.containerTopMobile]}>
          <Row className={styles.topNavbarContainer}>
            <Col xs={6} className={[styles.navContainer, styles.containerImage]}>
              <a href="/">
                <img src={logo} className={styles.logoImg} alt="Environmental Defenders Office Logo" />
              </a>
            </Col>
            <Col xs={6} className={[styles.navContainer, styles.btnContianerNavbar]}>
              {navbarDonate
                ? <Button tag="a" href={navbarDonate.url} className={styles.navButton}>
                  {navbarDonate.title}
                </Button>
                : null}
            </Col>
          </Row>
        </Col>
        <Col md={12} className={styles.navUlContainer}>
          <Row className={styles.containerLinks}>
            {navbar.map(item =>
              <Col key={item.id} xs={3} className={[styles.navContainer, styles.navItem]}>
                <a href={item.url} className={styles.navNavitagion}>
                  {item.title}
                </a>
              </Col>
            )}
            <Col xs={3} className={classnames("astm-search-menu is-menu is-dropdown menu-item", styles.navContainer, styles.searchCol)}>
              {search}
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Navbar;
